function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2004(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22.31,
    height: 9.97,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4242857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.155,
    y: 4.985
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.97,
    width: 22.31,
    height: 14.38,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.595
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.155,
    y: 17.16
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 24.35,
    width: 22.31,
    height: 24.02,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7183333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.155,
    y: 36.36
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 48.38,
    width: 22.31,
    height: 25.01,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7183333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.155,
    y: 60.885000000000005
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 73.38,
    width: 22.31,
    height: 25.42,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.462
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.155,
    y: 86.09
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 98.8,
    width: 22.31,
    height: 28.31,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.462
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.155,
    y: 112.955
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 127.11,
    width: 22.31,
    height: 30.28,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4788888888888887
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.155,
    y: 142.25
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 157.39,
    width: 22.31,
    height: 30.52,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.5775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.155,
    y: 172.64999999999998
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 187.91,
    width: 22.31,
    height: 31.1,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.231
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.155,
    y: 203.46
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 219,
    width: 22.31,
    height: 31.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.462
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.155,
    y: 234.8
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 250.6,
    width: 22.31,
    height: 33.78,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7183333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.155,
    y: 267.49
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 284.38,
    width: 22.31,
    height: 34.31,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.231
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.155,
    y: 301.53499999999997
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 318.7,
    width: 22.31,
    height: 37.87,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.187142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.155,
    y: 337.635
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 356.57,
    width: 22.31,
    height: 40.59,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7183333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.155,
    y: 376.865
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 397.16,
    width: 22.31,
    height: 47.19,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.462
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.155,
    y: 420.755
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 444.35,
    width: 22.31,
    height: 48.91,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.78875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.155,
    y: 468.805
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 493.26,
    width: 22.31,
    height: 50.35,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7183333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.155,
    y: 518.435
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 543.61,
    width: 22.31,
    height: 50.38,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7183333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.155,
    y: 568.8000000000001
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 593.99,
    width: 22.31,
    height: 51,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.78875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.155,
    y: 619.49
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 644.99,
    width: 22.31,
    height: 55.01,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.028181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.155,
    y: 672.495
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.31,
    y: 0,
    width: 31.62,
    height: 39.73,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5133333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.12,
    y: 19.865
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.93,
    y: 0,
    width: 31.78,
    height: 39.73,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.945
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.82,
    y: 19.865
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.71,
    y: 0,
    width: 32.5,
    height: 39.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 101.96,
    y: 19.865
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.2,
    y: 0,
    width: 33.22,
    height: 39.73,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.536666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 134.81,
    y: 19.865
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.43,
    y: 0,
    width: 33.24,
    height: 39.73,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.748571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 168.05,
    y: 19.865
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.67,
    y: 0,
    width: 33.33,
    height: 39.73,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.761428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.33499999999998,
    y: 19.865
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 0,
    width: 35.51,
    height: 39.73,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5509999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.755,
    y: 19.865
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 253.51,
    y: 0,
    width: 36.82,
    height: 39.73,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.136666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 271.92,
    y: 19.865
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.33,
    y: 0,
    width: 39.45,
    height: 39.73,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.93125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 310.055,
    y: 19.865
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.78,
    y: 0,
    width: 40.01,
    height: 39.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.9325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 349.78499999999997,
    y: 19.865
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 369.78,
    y: 0,
    width: 40.67,
    height: 39.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.96625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.11499999999995,
    y: 19.865
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 410.46,
    y: 0,
    width: 41.65,
    height: 39.73,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.9325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 431.28499999999997,
    y: 19.865
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 452.11,
    y: 0,
    width: 43.37,
    height: 39.73,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.621666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 473.795,
    y: 19.865
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 495.48,
    y: 0,
    width: 48.08,
    height: 39.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.973
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 519.52,
    y: 19.865
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 543.56,
    y: 0,
    width: 49.93,
    height: 39.73,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.675714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 568.525,
    y: 19.865
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 593.48,
    y: 0,
    width: 52.92,
    height: 39.73,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.946
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 619.94,
    y: 19.865
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 646.41,
    y: 0,
    width: 53.59,
    height: 39.73,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.621666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 673.2049999999999,
    y: 19.865
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.31,
    y: 39.73,
    width: 50.3,
    height: 42.61,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.101666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.459999999999994,
    y: 61.035
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.31,
    y: 82.34,
    width: 50.3,
    height: 43.26,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.815
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.459999999999994,
    y: 103.97
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.31,
    y: 125.6,
    width: 50.3,
    height: 43.37,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6141666666666663
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.459999999999994,
    y: 147.285
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.31,
    y: 168.97,
    width: 50.3,
    height: 43.41,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.823333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.459999999999994,
    y: 190.675
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.31,
    y: 212.38,
    width: 50.3,
    height: 43.62,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.724
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.459999999999994,
    y: 234.19
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.31,
    y: 256,
    width: 50.3,
    height: 44.52,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.565
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.459999999999994,
    y: 278.26
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.31,
    y: 300.52,
    width: 50.3,
    height: 44.92,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.615
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.459999999999994,
    y: 322.97999999999996
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.31,
    y: 345.44,
    width: 50.3,
    height: 46.14,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.459999999999994,
    y: 368.51
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.31,
    y: 391.58,
    width: 50.3,
    height: 46.41,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.282
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.459999999999994,
    y: 414.78499999999997
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.31,
    y: 437.99,
    width: 50.3,
    height: 47.54,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.923333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.459999999999994,
    y: 461.76
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.31,
    y: 485.53,
    width: 50.3,
    height: 51.76,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.588888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.459999999999994,
    y: 511.40999999999997
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.31,
    y: 537.29,
    width: 50.3,
    height: 54.02,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.383333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.459999999999994,
    y: 564.3
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.31,
    y: 591.3,
    width: 50.3,
    height: 54.32,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.2875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.459999999999994,
    y: 618.4599999999999
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.31,
    y: 645.62,
    width: 50.3,
    height: 54.38,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.766666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.459999999999994,
    y: 672.8100000000001
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.61,
    y: 39.73,
    width: 48.52,
    height: 56.67,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.9314285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 96.87,
    y: 68.065
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.13,
    y: 39.73,
    width: 51.66,
    height: 56.67,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.4575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 146.95999999999998,
    y: 68.065
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.78,
    y: 39.73,
    width: 52.05,
    height: 56.67,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.783333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 198.805,
    y: 68.065
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.84,
    y: 39.73,
    width: 52.33,
    height: 56.67,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.54125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 251.005,
    y: 68.065
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.17,
    y: 39.73,
    width: 55.04,
    height: 56.67,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.862857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 304.69,
    y: 68.065
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.21,
    y: 39.73,
    width: 57.24,
    height: 56.67,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 360.83,
    y: 68.065
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 389.45,
    y: 39.73,
    width: 59.39,
    height: 56.67,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.095714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 419.145,
    y: 68.065
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 448.84,
    y: 39.73,
    width: 60.89,
    height: 56.67,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 479.28499999999997,
    y: 68.065
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.73,
    y: 39.73,
    width: 63.1,
    height: 56.67,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 541.28,
    y: 68.065
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 572.83,
    y: 39.73,
    width: 63.16,
    height: 56.67,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.08375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 604.4100000000001,
    y: 68.065
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 635.99,
    y: 39.73,
    width: 64.01,
    height: 56.67,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.095714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 667.995,
    y: 68.065
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.61,
    y: 96.4,
    width: 62.08,
    height: 58.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.351428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.65,
    y: 125.63000000000001
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.61,
    y: 154.86,
    width: 62.08,
    height: 58.6,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.72
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.65,
    y: 184.16000000000003
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.61,
    y: 213.46,
    width: 62.08,
    height: 61.22,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.203333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.65,
    y: 244.07
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.61,
    y: 274.67,
    width: 62.08,
    height: 66.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.868571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.65,
    y: 308.01
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.61,
    y: 341.36,
    width: 62.08,
    height: 68.84,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.346666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.65,
    y: 375.78000000000003
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.61,
    y: 410.19,
    width: 62.08,
    height: 69.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.416
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.65,
    y: 444.865
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.61,
    y: 479.54,
    width: 62.08,
    height: 70.67,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.76
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.65,
    y: 514.875
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.61,
    y: 550.21,
    width: 62.08,
    height: 73.43,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.868571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.65,
    y: 586.9250000000001
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.61,
    y: 623.64,
    width: 62.08,
    height: 76.36,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.868571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.65,
    y: 661.8199999999999
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.69,
    y: 96.4,
    width: 69.05,
    height: 75.15,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.672222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 169.215,
    y: 133.97500000000002
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.74,
    y: 96.4,
    width: 69.42,
    height: 75.15,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 238.45000000000002,
    y: 133.97500000000002
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273.15,
    y: 96.4,
    width: 69.62,
    height: 75.15,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.962000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 307.96,
    y: 133.97500000000002
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 342.77,
    y: 96.4,
    width: 70.15,
    height: 75.15,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.5375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 377.84499999999997,
    y: 133.97500000000002
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.93,
    y: 96.4,
    width: 70.31,
    height: 75.15,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.718333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 448.08500000000004,
    y: 133.97500000000002
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 483.24,
    y: 96.4,
    width: 70.72,
    height: 75.15,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.857777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 518.6,
    y: 133.97500000000002
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 553.95,
    y: 96.4,
    width: 71.47,
    height: 75.15,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.294
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 589.6850000000001,
    y: 133.97500000000002
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 625.43,
    y: 96.4,
    width: 74.57,
    height: 75.15,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.913999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 662.7149999999999,
    y: 133.97500000000002
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.69,
    y: 171.56,
    width: 81.62,
    height: 74.13,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.236666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.5,
    y: 208.625
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.69,
    y: 245.69,
    width: 81.62,
    height: 87.29,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.2025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.5,
    y: 289.335
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.69,
    y: 332.98,
    width: 81.62,
    height: 88.94,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.324
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.5,
    y: 377.45000000000005
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.69,
    y: 421.92,
    width: 81.62,
    height: 91.98,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.405
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.5,
    y: 467.91
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.69,
    y: 513.9,
    width: 81.62,
    height: 92.89,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.2025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.5,
    y: 560.345
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.69,
    y: 606.79,
    width: 81.62,
    height: 93.21,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.2025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.5,
    y: 653.395
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.31,
    y: 171.56,
    width: 92.79,
    height: 85.93,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.275714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 262.705,
    y: 214.525
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 309.1,
    y: 171.56,
    width: 95.58,
    height: 85.93,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.275714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 356.89000000000004,
    y: 214.525
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 404.68,
    y: 171.56,
    width: 96.9,
    height: 85.93,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.74125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 453.13,
    y: 214.525
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501.58,
    y: 171.56,
    width: 99.06,
    height: 85.93,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.74125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 551.11,
    y: 214.525
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 600.65,
    y: 171.56,
    width: 99.35,
    height: 85.93,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.186
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 650.3249999999999,
    y: 214.525
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.31,
    y: 257.48,
    width: 96.26,
    height: 92.69,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.448333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.44,
    y: 303.82500000000005
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.31,
    y: 350.17,
    width: 96.26,
    height: 93.27,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.44,
    y: 396.805
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.31,
    y: 443.44,
    width: 96.26,
    height: 118.12,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.750909090909092
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.44,
    y: 502.5
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.31,
    y: 561.56,
    width: 96.26,
    height: 138.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.626000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.44,
    y: 630.78
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 312.57,
    y: 257.48,
    width: 115,
    height: 127.8,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.07,
    y: 321.38
  }, "\n        Buncombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.57,
    y: 257.48,
    width: 120.08,
    height: 127.8,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.013333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 487.61,
    y: 321.38
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 547.65,
    y: 257.48,
    width: 152.35,
    height: 127.8,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.257142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 623.8249999999999,
    y: 321.38
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 312.57,
    y: 385.28,
    width: 232.31,
    height: 120.07,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.00875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 428.725,
    y: 445.31499999999994
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 312.57,
    y: 505.35,
    width: 232.31,
    height: 194.65,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.695454545454545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 428.725,
    y: 602.6750000000001
  }, "\n        Mecklenburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 544.88,
    y: 385.28,
    width: 155.12,
    height: 314.72,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 38.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 622.44,
    y: 542.64
  }, "\n        Wake\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2004);
export default __webpack_public_path__ + "static/media/2004.310e43da74504faafff1a68145293da2.svg";
export { ForwardRef as ReactComponent };